export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_change') || '产品变更',
    icon: 'el-icon-edit',
    menuType: 'change',
    divided: true,
    allow: 'C',
    disabled: ({ approvalStatus, isAllowChange }) => {
      return isAllowChange ? !['N', 'R'].includes(approvalStatus) : true
    },
  },
  {
    text: that.$l('menu_text_cancel') || '取消变更',
    icon: 'el-icon-delete',
    menuType: 'cancel',
    allow: 'D',
    disabled: ({ approvalStatus, isAllowChange }) => {
      return isAllowChange ? !['N', 'R'].includes(approvalStatus) : true
    },
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ approvalStatus, isAllowChange }) => {
      return isAllowChange ? !['N', 'R'].includes(approvalStatus) : true
    },
  },
  {
    text: that.$l('menu_text_review') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'review',
    allow: 'Y',
    disabled: ({ approvalStatus }) => approvalStatus !== 'S',
  },
  {
    text: that.$l('menu_text_reject') || '审核驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'R',
    disabled: ({ approvalStatus }) => approvalStatus !== 'S',
  },
  {
    text: that.$l('menu_text_export') || '导出合同',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: true,
    allow: 'E',
    disabled: ({ approvalStatus }) => approvalStatus !== 'Y',
  },
]
